<template>
  <div class="filter_screen">
    <div>
      <div class="d-flex justify-content-between align-items-center my-3" v-show="sidedisplay">
        <p class="light-txt ps-0">Filter</p>
      </div>
      <div :class="{ sidedisplaydiv: sidedisplay }" class="row">
        <b-row>
          <b-col lg="12">
            <div class="field">
              <Datepicker class="date" label="From Date" name="" id="" v-model="SearchValue.fromdate" @date-select="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)" @clear-click="FromDateClear"
                :showButtonBar="showButtonBar" :minDate="StartDate" :maxDate="EndDate" />
            </div>
          </b-col>

          <b-col lg="12">
            <div class="field">
              <Datepicker class="date" label="To Date" name="" id="" v-model="SearchValue.todate" @date-select="
                $emit('dateSearch', SearchValue.fromdate, SearchValue.todate)
                " @clear-click="ToDateClear" :showButtonBar="showButtonBar" :minDate="StartDate" :maxDate="EndDate" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <slot name="filterslot"></slot>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col>
          <div class="float-end me-1 mt-3">
            <!-- <Footer label="Apply" class="mt-4" /> -->
            <button class="btn resetallfilter me-3" @click="ResetFilter()">
              Reset
            </button>
            <button class="btn applyfilter me-2" @click="ApplyFilter()">
              Apply
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import Datepicker from "./DatePicker.vue";
import Footer from "./Footer.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    Datepicker,
    Footer,
  },
  props: {
    sidedisplay: {
      type: Boolean,
      default: false,
    },
    ClearDateFilter: {
      type: Object,
      default: {},
    },
    showButtonBar: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {

    onMounted(() => {
      if (CallPeriod == 1) {
        StartDate.value = new Date();
        EndDate.value = new Date();
      } else if (CallPeriod == 2) {
        StartDate.value = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        EndDate.value = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      }
    })

    const router = useRoute();
    let CallPeriod = Number(router.query.filter);
    let StartDate = ref();
    let EndDate = ref();



    let SearchValue = ref({
      // inputValue: "",
      fromdate: "",
      todate: "",
    });

    function ApplyFilter() {
      debugger;
      emit("FilterValues", SearchValue.value);
    }

    function ResetFilter() {
      debugger;
      SearchValue.value.fromdate = "";
      SearchValue.value.todate = "";

      emit("ResetValues", SearchValue.value);
    }

    function FromDateClear() {
      debugger;
      SearchValue.value.fromdate = "";
    }

    function ToDateClear() {
      debugger;
      SearchValue.value.todate = "";
    }

    watch(props.ClearDateFilter, (newValue: any) => {
      debugger;
      if (newValue.fromDate == "" || newValue.toDate == "") {
        SearchValue.value.fromdate = "";
        SearchValue.value.todate = "";
      }
    });

    return {
      SearchValue,
      ApplyFilter,
      ResetFilter,
      FromDateClear,
      ToDateClear,
      StartDate,
      EndDate
    };
  },
});
</script>

<style>
.sidedisplaydiv {
  max-height: 46vh;
  overflow: auto;
}

.sidebar_filter .p-sidebar-header {
  padding: 0.9rem0rem !important;
}

.sidebar_filter {
  background-color: #ffffff !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

/* .table_screen>div:nth-child(1) {
  background-color: #f7f8f9;
  min-height: max-content;
  max-height: 80vh;
} */
.table_screen .field {
  margin-left: 0px;
}

.resetallfilter {
  border: 1px solid #4582ff !important;
  padding: 5px 20px !important;
  color: #4582ff !important;
  font-size: 12px !important;
  border-radius: 5px !important;
  min-width: max-content;
}

.applyfilter {
  border: 1px solid #4582ff !important;
  background-color: #4582ff !important;
  padding: 5px 20px !important;
  color: #ffffff !important;
  font-size: 12px !important;
  border-radius: 5px !important;
  min-width: max-content;
}

.filter_screen {
  background-color: #f7f8f9;
  padding: 15px;
  /* min-height: max-content;
  max-height: 80vh; */
  height: 75vh;
}

.filter_screen .field label {
  font-size: 12px;
}

.filter_screen .p-inputtext {
  font-size: 12px;
}

.filter_screen .p-multiselect-label {
  font-size: 12px;
}

.filter_screen .p-badge {
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
}

.chip_class {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chip_class .p-chip .p-chip-text {
  font-size: 12px;
}

.filter_chip .pi {
  font-size: 12px;
  margin-left: 7px;
}

@media only screen and (max-width: 545px) {
  .chip_class {
    display: flex;
    flex-direction: column-reverse;
  }

  .chip_class div:nth-child(2) {
    width: 100%;
    margin-bottom: 15px;
  }
}

.table_screen>div:only-child {
  width: 100%;
}

@media only screen and (min-width: 1400px) {
  .filter_screen {
    height: 65vh;
  }
}
</style>
